/* Copyright (C) ZibatRan, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Zibatran development team, Dec 2020
 */

function reducer(state = {
    schoolPageData: null,
    BreadCrumb: [],

}, action) {

    switch (action.type) {
        case "handleSchoolPageData":
            return {
                ...state,
                schoolPageData: action.value
            };
        case "handleBreadCrumb":
            return {
                ...state,
                BreadCrumb: action.value
            };
        default:
            return state;
    }
}


export default reducer;
